import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=adaa2020"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontal.vue?vue&type=style&index=0&id=adaa2020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports